
import React from "react";
import { Modal2 } from "../../components/modal";
import {Spinner} from "../../funcs/utils";


const renderInput = (component, prm) => {
  const style = {
    width: "100%",
  }
  const on_change = ev => {
    component.setState({
      [prm]: ev.target.value,
    })
  }
  return (
    <input
      type={"text"}
      style={style}
      value={component.state[prm]}
      onChange={on_change}
    />
  )
}

const ComposePopup = props => {
  const sending = props.component.props.inbox.sending;

  const container_style = {
    width: "60rem",
  }
  const label_style = {
    flex: "0 0 8rem",
    fontWeight: "bold",
    fontSize: "1.2rem",
  };
  const input_style = {
    paddingTop: "0.2rem",
    flex: "1",
  }

  const button_list = [
    {
      label: "Cancel",
      cb: props.on_cancel,
      disable: sending,
    },
    {
      label: sending ? (<Spinner/>) : "Send",
      cb: props.on_send,
      disable: sending,
    }
  ];

  const text_area_style = {
    width: "100%",
    height: "10rem",
  }

  const on_change = ev => {
    props.component.setState({
      text: ev.target.value,
    })
  }

  return (
    <Modal2
      container_style={container_style}
      show={true}
      buttonList={button_list}
      title={"To: " + props.to}>
      <div style={{display: "flex"}}>
        <div style={label_style}>
          Subject
        </div>
        <div style={input_style}>
          { renderInput(props.component, "subject") }
        </div>
      </div>
      <div style={{height: "1rem"}}/>
      <div style={{display: "flex"}}>
        <div style={label_style}>
          Message
        </div>
        <div style={input_style}>
          <textarea
            onChange={on_change}
            value={props.component.state.text}
            style={text_area_style}/>
        </div>
      </div>
    </Modal2>
  )

};

export { ComposePopup };
